// extracted by mini-css-extract-plugin
export default {"root":"Qok61k0wj4hmRJsM8KzU","single-col":"Nn6Mn6fvwoiOupcx2H5M","singleCol":"Nn6Mn6fvwoiOupcx2H5M"};